module.exports = __webpack_public_path__ + "static/media/store-scanner-beep-90395.e43e76d7.mp3";